import type { ProfileUser } from "../types/profile";
import type { UserAction } from "./actions";

export interface UserState {
  currentUser: ProfileUser | "" | null;
  userData: ProfileUser[];
  usersAchievements: { usersNumberRatePerDay: Record<string, number> };
}
const user: UserState = {
  currentUser: "",
  userData: [],
  usersAchievements: { usersNumberRatePerDay: {} }
};

export const userReducer = (state: UserState = user, action: UserAction): UserState => {
  switch (action.type) {
    case "setCurrentUser": {
      return {
        ...state,
        currentUser: action.payload
      };
    }
    default:
      return state;
  }
};
